module.exports = __webpack_public_path__ + "img/icon-math-plus.3a5e9531.svg";